exports = module.exports = function() {
	var allowedUrls = ["v.underlineme.com"];
	var url = new URL(window.location.href);
	if (allowedUrls.includes(url.hostname)) {
		return true;
	} else {
		return false;
	}
};
